import { OnboardingWizard } from "@/features/portal/components/onboarding/onboarding-wizard";

/** `/portal/onboarding` — the tabbed onboarding wizard (autosave per field). */
export default function OnboardingWizardPage() {
  return <OnboardingWizard />;
}
